"use client"

import type { ReactNode } from "react"
import { RefreshCw } from "lucide-react"
import { useTranslations } from "next-intl"
import { Button } from "@/components/ui/button"
import { WhatsappTemplateCreationGuide } from "@/components/agent-tasks/whatsapp-template-creation-guide"

export function TemplateSettingsCard({ channelId, refreshing, onRefresh, children, details }: {
  channelId: string; refreshing: boolean; onRefresh: () => void; children: ReactNode; details?: ReactNode
}) {
  const t = useTranslations("WhatsappTemplates")
  return <section className="space-y-4 rounded-lg border p-4">
    <h3 className="text-base font-semibold"><span>{t("settingsCardTitle")}</span></h3>
    <div className="flex flex-wrap items-end gap-3">
      <div className="min-w-0 flex-1 basis-64">{children}</div>
      <Button type="button" variant="outline" disabled={!channelId || refreshing} onClick={onRefresh} className="shrink-0">
        <RefreshCw aria-hidden="true" className={`mr-2 h-4 w-4${refreshing ? " animate-spin" : ""}`} />
        <span>{t("refreshTemplatesAction")}</span>
      </Button>
    </div>
    {details}
    <div className="border-t pt-4"><WhatsappTemplateCreationGuide channelId={channelId} /></div>
  </section>
}
